import {createElement} from "../util/utils";
const { __ } = wp.i18n;
import popup from '../modules/Popup';

export default class MediaUploader {
  constructor(args = {}) {
    const defaults = {
      fileInputSelector: '#comment-attachment-image-input',
      fileDropZoneSelector: '#comment-attachment-drop-zone',
      buttonSelector: '.comment-attachment-image-button',
    }

    this.args = {...defaults, ...args};
    this.files = [];
    this.fileInput = document.querySelector(this.args.fileInputSelector);
    this.button = document.querySelector(this.args.buttonSelector);
    this.dropZone = document.querySelector(this.args.fileDropZoneSelector);
    this.args.maxFiles = this.fileInput && this.fileInput.dataset.maxFiles ? parseInt(this.fileInput.dataset.maxFiles) : null;
    this.args.maxFileSize = this.fileInput && this.fileInput.dataset.maxSize ? this.fileInput.dataset.maxSize * 1048576 : 2097152;
    this.args.accept = this.fileInput ? this.fileInput.getAttribute('accept').split(',') : null;

    if(this.fileInput) {
      this.attachHandlers();
    }

  }

  attachHandlers()
  {
    this.fileInput.addEventListener('change', this.handleChange.bind(this))
    if(this.dropZone) {
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => this.dropZone.addEventListener(eventName, this.preventDefaults));
      ['dragenter', 'dragover'].forEach(eventName => this.dropZone.addEventListener(eventName, this.highlight.bind(this)));
      ['dragleave', 'drop'].forEach(eventName => this.dropZone.addEventListener(eventName, this.unhighlight.bind(this)));
      this.dropZone.addEventListener('drop', this.handleChange.bind(this));
      this.dropZone.addEventListener('click', event => {
        if(event.target.classList.contains('btn-delete-attachment')) {
          this.removeAttachment(event.target);
        }
      });
    }

    if(this.button) {
      this.button.addEventListener('click', () => this.fileInput.click());
    }
  }

  handleChange(event)
  {
    let isDrop = event.type === 'drop';

    let files = isDrop ? [...event.dataTransfer.files] : [...event.target.files];

    if(files.length > 0) {


      let errors = [];

      files.every(file => {
        let accept = true;
        if (this.args.maxFiles && this.files.length >= this.args.maxFiles) {
          this.onUploadError(`${__('Maximum number of files to upload')}: ${this.args.maxFiles}`);
          return false;
        }

        if (!this.acceptanceCheck(file)) {
          errors.push(`${__('File upload error', 'canopia')} ${file.name}. ${__('This file type is not supported', 'canopia')}`);
          accept = false;
        } else if (file.size > this.args.maxFileSize) {
          errors.push(`${__('File upload error', 'canopia')} ${file.name}. ${__('Maximum file size', 'canopia')}: ${(this.args.maxFileSize / 1048576).toFixed()}MB`);
          accept = false;
        }

        if (accept) {
          this.files.push(file);
          this.previewFile(file);
        }

        return true;
      });

      if (errors.length > 0) {
        this.onUploadError(errors);
      }
    }

    const fileList = this.arrayToFileList(this.files);

    if(fileList) {
      this.fileInput.files = fileList;
    }
  }


  acceptanceCheck(file)
  {
    if(!this.args.accept || !Array.isArray(this.args.accept) || !file.type) {
      return false;
    }

    if(this.args.accept.includes(file.type)) {
      return true;
    }

    const fileTypeArray = file.type.split('/');

    return !!this.args.accept.includes(`${fileTypeArray[0]}/*`);
  }

  previewFile(file)
  {
    const reader = new FileReader();
    const preview = createElement({
      tagname: 'div',
      classes: ['img-preview']
    });

    reader.readAsDataURL(file);
    reader.onloadend = () => {
      if(file.type.match('image')) {
        createElement({
          tagname: 'img',
          attributes: {
            src: reader.result,
          },
          parent: preview,
        });
    } else if(file.type.match('video')) {
        const video = createElement({
          tagname: 'video',
          attributes: {
            autoplay: true,
            src: reader.result,
          },
          parent: preview,
        });

        video.muted = true;
        video.loop = true;
        video.controls = false;
      }

      const button = createElement({
        tagname: 'button',
        classes: ['btn-default', 'btn-delete-attachment', 'icon-cross'],
        attributes: {
          type: 'button'
        },
        dataset: {
          name: file.name,
        },
        parent: preview,
      });

      createElement({
        tagname: 'span',
        classes: ['sr-only'],
        textContent: __('Remove', 'canopia'),
        parent: button
      });

      this.dropZone.appendChild(preview);
    }
  }

  highlight()
  {
    this.dropZone.classList.add('highlight');
  }

  unhighlight()
  {
    this.dropZone.classList.remove('highlight');
  }

  preventDefaults(e)
  {
    e.preventDefault();
    e.stopPropagation();
  }

  onUploadError(message)
  {
    let msg = '';
    if(Array.isArray(message)) {
      message.map(item => {
        msg += `<p>${item}</p>`;
      });
    } else {
      msg = `<p>${message}</p>`;
    }
    popup.open({
      title: __('Oh no...', 'canopia'),
      type: 'warning',
      message: msg,
      close: {
        text: __('Try again', 'canopia'),
      }
    });
  }

  removeAttachment(button) {
    const preview = button.closest('.img-preview');
    this.files = this.files.filter(file => file.name !== button.dataset.name);
    const fileList = this.arrayToFileList(this.files);
    if(fileList) {
      this.fileInput.files = fileList;
    }
    if(preview) {
      preview.classList.add('removing');
      setTimeout(() => preview.remove(), 300);
    }
  }

  arrayToFileList(items)
  {
    if(!Array.isArray(items)) {
      return null;
    }
    const dt = new DataTransfer();

    items.forEach(item => dt.items.add(item));

    return dt.files;
  }
}
